import PropTypes from "prop-types"
import { DATE } from "helpers/shapes"
import { formatLongDate } from "helpers/formatters/dates"
import DailyDetails from "modules/factor-trends/components/daily-details"
import "./style.scss"

function FactorTrendsRiskDetails({
  startDate,
  endDate,
  selectedDate,
  details,
  openFactorProfile,
  sort,
  order,
  csvData,
  drift,
}) {
  return <div className="modules_factor-trends-risk-details">
    <h4 className="header">As of {formatLongDate(selectedDate)}</h4>
    <DailyDetails {...{
      calculationType: "risk",
      openFactorProfile,
      noFactorDrilldown: true,
      data: details,
      factorTable: true,
      sort,
      order,
      csvData,
      drift,
      startDate,
      endDate,
    }}
    />
  </div>
}

FactorTrendsRiskDetails.propTypes = {
  startDate: DATE.isRequired,
  endDate: DATE.isRequired,
  selectedDate: DATE.isRequired,
  details: PropTypes.array.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  sort: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  csvData: PropTypes.shape({
    data: PropTypes.array,
    fileName: PropTypes.string,
    type: PropTypes.string,
  }),
  drift: PropTypes.object,
}

export default FactorTrendsRiskDetails
